var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.logged_in) ? _c('nav', {
    staticClass: "navbar navbar-default",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show_nav = !_vm.show_nav
      }
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), (_vm.store) ? _c('span', {
    staticClass: "navbar-brand navbar-left",
    attrs: {
      "id": "nav-store-name"
    }
  }, [_vm._v(_vm._s(_vm.store.name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "navbar-brand navbar-left hidden-xs",
    staticStyle: {
      "padding-top": "10px"
    }
  })]), _vm._v(" "), _c('collapse', {
    staticClass: "navbar-collapse",
    model: {
      value: (_vm.show_nav),
      callback: function($$v) {
        _vm.show_nav = $$v
      },
      expression: "show_nav"
    }
  }, [_c('ol', {
    staticClass: "navbar-center breadcrumb text-center hidden-xs ribbon both_ribbon"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'store-list'
      }
    }
  }, [_vm._v("1. Stores")])], 1), _vm._v(" "), (_vm.show_store_jobs) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'store-jobs',
        params: {
          store_id: _vm.store.id
        }
      }
    }
  }, [_vm._v("2. Job Selection")])], 1) : _vm._e(), _vm._v(" "), (_vm.show_job_logger) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'job-logger',
        params: {
          job_id: _vm.job.id
        }
      }
    }
  }, [_vm._v("3. Issue Marker")])], 1) : _vm._e(), _vm._v(" "), (_vm.show_job_urgency) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'job-urgency',
        params: {
          job_id: _vm.job.id
        }
      }
    }
  }, [_vm._v("4. Urgency")])], 1) : _vm._e(), _vm._v(" "), (_vm.show_job_review) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'job-review',
        params: {
          job_id: _vm.job.id
        }
      }
    }
  }, [_vm._v("5. Review")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right hidden-xs"
  }, [_c('dropdown', {
    attrs: {
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    staticStyle: {
      "padding-left": "30px",
      "padding-right": "30px"
    },
    attrs: {
      "data-role": "trigger"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/dashboard/"
    }
  }, [_vm._v("Go to Dashboard")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user.email) + " Logout")])])])], 2)], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav visible-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/dashboard/"
    }
  }, [_vm._v("Go to Dashboard")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user.email) + " Logout")])])])])], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae37726","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/logger/LoggerNavbar.vue
// module id = 550
// module chunks = 0